import React, { RefObject, useEffect, useRef } from 'react';

import { TextField } from '@ublend-npm/aulaui-next';
import { InputToolbar, Suffix } from './InputWithActions.styled';

type InputWithActionsProps = {
  dataTestId: string;
  inputRef: RefObject<HTMLInputElement>;
  inputValue: string;
  isVisible: boolean;
  onDismiss: () => void;
  onChange: (e: HTMLInputElement) => void;
  onInputKeyDown: (e: React.KeyboardEvent<HTMLElement>) => void;
  label: string;
  showError?: boolean;
  errorText?: string;
  endAdornment?: string | null;
};

export const InputWithActions = ({
  dataTestId,
  inputRef,
  inputValue,
  isVisible,
  onDismiss,
  onChange,
  onInputKeyDown,
  label,
  showError,
  errorText,
  endAdornment,
}: InputWithActionsProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const clickEvent = (event: MouseEvent) => {
      if (
        wrapperRef.current === event.target ||
        wrapperRef.current?.contains(event.target as Node)
      ) {
        inputRef.current?.focus();
      } else {
        onDismiss();
      }
    };

    document.addEventListener('click', clickEvent);

    return () => document.removeEventListener('click', clickEvent);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <InputToolbar data-testid={dataTestId} ref={wrapperRef}>
      <TextField
        id="input-field"
        inputRef={inputRef}
        type="text"
        placeholder=" "
        value={inputValue}
        onChange={onChange}
        onKeyDown={onInputKeyDown}
        label={label}
        error={showError}
        helperText={
          showError ? (
            <span data-testid="invalid-input">{errorText}</span>
          ) : (
            <span data-testid="helper-text">
              Enter to <span className="boldAction">apply changes</span> -
              Escape to <span className="boldAction">cancel</span>
            </span>
          )
        }
        endAdornment={<Suffix>{endAdornment}</Suffix>}
      />
    </InputToolbar>
  );
};
